// from https://stackoverflow.com/questions/2901102/how-to-format-a-number-with-commas-as-thousands-separators
export function formatNumbersWithCommas(num: number): string {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
